import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'

function AlbumCard() {
    const feed = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

    return (
        <div className="flex flex-col mt-10">
            <div className="self-start text-3xl font-bold text-right whitespace-nowrap text-zinc-900">
                صور من فلسطين
            </div>
            <div className="mt-8 w-full max-md:max-w-full">
                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
                    {/* Start of Card */}
                    {feed.filter((item, index) => index < 4).map((filteredItem, index) => (

                        <div className="flex flex-col w-full max-md:ml-0 max-md:w-full">
                            <div className="overflow-hidden relative flex-col grow justify-center items-center px-16 pt-32 pb-12 text-2xl font-bold text-right text-white whitespace-nowrap rounded-md aspect-[0.94] max-md:px-5 max-md:pt-10 max-md:mt-5">
                                <LazyLoadImage
                                    loading="lazy"
                                    srcSet="https://cdn.builder.io/api/v1/image/assets/TEMP/0bfc33e3ae2864d6bdf86ed193802da30bd0b721ce907868027e211f71d50902?apiKey=1b00d6cd98374704a0468862af744bdf&width=100 100w, https://cdn.builder.io/api/v1/image/assets/TEMP/0bfc33e3ae2864d6bdf86ed193802da30bd0b721ce907868027e211f71d50902?apiKey=1b00d6cd98374704a0468862af744bdf&width=200 200w, https://cdn.builder.io/api/v1/image/assets/TEMP/0bfc33e3ae2864d6bdf86ed193802da30bd0b721ce907868027e211f71d50902?apiKey=1b00d6cd98374704a0468862af744bdf&width=400 400w, https://cdn.builder.io/api/v1/image/assets/TEMP/0bfc33e3ae2864d6bdf86ed193802da30bd0b721ce907868027e211f71d50902?apiKey=1b00d6cd98374704a0468862af744bdf&width=800 800w, https://cdn.builder.io/api/v1/image/assets/TEMP/0bfc33e3ae2864d6bdf86ed193802da30bd0b721ce907868027e211f71d50902?apiKey=1b00d6cd98374704a0468862af744bdf&width=1200 1200w, https://cdn.builder.io/api/v1/image/assets/TEMP/0bfc33e3ae2864d6bdf86ed193802da30bd0b721ce907868027e211f71d50902?apiKey=1b00d6cd98374704a0468862af744bdf&width=1600 1600w, https://cdn.builder.io/api/v1/image/assets/TEMP/0bfc33e3ae2864d6bdf86ed193802da30bd0b721ce907868027e211f71d50902?apiKey=1b00d6cd98374704a0468862af744bdf&width=2000 2000w, https://cdn.builder.io/api/v1/image/assets/TEMP/0bfc33e3ae2864d6bdf86ed193802da30bd0b721ce907868027e211f71d50902?apiKey=1b00d6cd98374704a0468862af744bdf&"
                                    className="object-cover absolute inset-0 size-full"
                                />
                                عرض المزيد
                            </div>
                        </div>
                    ))}
                    {/* End of Card */}
                </div>
            </div>

        </div>
    )
}

export default AlbumCard